import * as Cesium from "cesium";
import React from "react";
import { useAppSelector } from "~/redux/store/store";
import {
  CesiumGeopickingItem,
  CesiumMeasurementItem,
} from "../types/CesiumMapItems";
import {
  CesiumCadPopup,
  CesiumGeoJsonFeatureProperties,
} from "./CesiumCadPopup";
import { CesiumGeopickingPopup } from "./CesiumGeopickingPopup";
import { CesiumMeasurementPopup } from "./CesiumMeasurementPopup";

type CesiumPopupArgs = {
  viewer: Cesium.Viewer;
};

const CesiumPopups = ({ viewer }: CesiumPopupArgs): JSX.Element | null => {
  const hoveredItem = useAppSelector((s) => s.map.hoveredCesiumItem);
  const selectedItem = useAppSelector((s) => s.map.selectedCesiumItem);

  const type = selectedItem?.type ?? hoveredItem?.type;
  if (!type) return null;

  switch (type) {
    case "measurement":
      return hoveredItem || selectedItem ? (
        <CesiumMeasurementPopup
          viewer={viewer}
          clickData={selectedItem as CesiumMeasurementItem}
          hoverData={hoveredItem as CesiumMeasurementItem}
        />
      ) : null;
    case "geopicking":
      return hoveredItem || selectedItem ? (
        <CesiumGeopickingPopup
          clickData={selectedItem as CesiumGeopickingItem}
          hoverData={hoveredItem as CesiumGeopickingItem}
        />
      ) : null;

    case "cad":
      return selectedItem ? (
        <CesiumCadPopup
          clickData={selectedItem as unknown as CesiumGeoJsonFeatureProperties}
          hoverData={undefined}
        />
      ) : null;

    default:
      return null;
  }
};

export default CesiumPopups;
